/**
 * Project's library of different colors
 *
 * AEVI Color Combinations:
 * Primary
 * - Background: AeviOffWhite, Foreground: AeviHeroGreen
 * - Background: AeviHeroGreen, Foreground: AeviDarkGreen
 * - Background: AeviHeroGreen, Foreground: AeviOffWhite
 * Secondary
 * - Background: AeviBlack, Foreground: AeviHeroGreen
 * - Background: AeviLightPink, Foreground: AeviOffWhite
 * - Background: AeviDarkGreen, Foreground: AeviOffWhite
 * - Background: AeviDarkGreen, Foreground: AeviHeroGreen
 * */
export enum Palette {
    // General colors
    White = "#FFFFFF",
    // AEVI Specific colors
    HeroGreen = "#33CC6B",
    AeviBlack = "#230211",
    FormText = "#8B7D82",
    MidGray = "#D8D8D8",
    MenuScroll = "#FFA5A9",
    AeviRed = "#FF003C",
    DarkGreen = "#004C31",
    Highlight = "#004C31",
    LightPink = "#FF9FA6",
    LightGreen = "#b7eb8f",
    PalePink = "#FFF2F0",
    PaleGreen = "#F6FFED",
    Warning = "#F6AA53",
    Blue = "#1890FF",
    DisabledColor = "rgba(0, 0, 0, 0.25)",
    DisabledBackground = "rgba(0, 0, 0, 0.04)",
    ShadowStartColor = "rgba(0, 0, 0, 0.3)",
    ShadowEndColor = "rgba(50, 50, 93, 0.25)",
}
